import React from 'react';
import classNames from 'classnames';

import SEO from '../components/SEO';
import LegalNav from '../components/LegalNav';
import RenderStaticHTML from '../components/RenderStaticHTML';

import eulaContent from '../data/eula-content.js';

const nsBase = 'page';
const ns = `${ nsBase }-legal`;

const pageContent = eulaContent;

const Warranty = () => {
	const rootClassnames = classNames({
		[`page-eula`]: true,
		[`${ ns }`]: true,
	});

	return (
		<div className={rootClassnames}>
			<SEO title={'EULA'} />
			<LegalNav />
			<div className={`${ ns }__page`}>
				<div className={'container-fluid'}>
					<h1 className={`${ ns }__title`}>EULA</h1>
					<div className={`${ ns }__content`}>
						<RenderStaticHTML html={pageContent} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Warranty;
